import { useContext } from 'react';

import {
  AccountModalDispatchContext,
  AccountModalStateContext,
} from 'account/providers/AccountModalProvider';

export const useAccountModalDispatch = () => useContext(AccountModalDispatchContext);
export const useAccountModalState = () => useContext(AccountModalStateContext);
